export enum Route {
  ROOT = 'ROOT',
  LOGIN = 'LOGIN',
  RESET_PASSWORD = 'RESET_PASSWORD',
  DOCUMENT_VIEWER = 'DOCUMENT_VIEWER',
  SELECT_COMPANY = 'SELECT_COMPANY',
  HOME = 'HOME',

  FORBIDDEN = 'FORBIDDEN',
  SYSTEM_ERROR = 'SYSTEM_ERROR',
  ACCOUNT_MANAGEMENT = 'ACCOUNT_MANAGEMENT',
  ACCOUNT_MANAGEMENT_CREATE_ACCOUNT = 'ACCOUNT_MANAGEMENT_CREATE_ACCOUNT',
  ACCOUNT_MANAGEMENT_EDIT_ACCOUNT = 'ACCOUNT_MANAGEMENT_EDIT_ACCOUNT',
  ACCOUNT_MANAGEMENT_VIEW_ACCOUNT = 'ACCOUNT_MANAGEMENT_VIEW_ACCOUNT',
  ACCOUNT_MANAGEMENT_CREATE_DEPARTMENT = 'ACCOUNT_MANAGEMENT_CREATE_DEPARTMENT',
  ACCOUNT_MANAGEMENT_EDIT_DEPARTMENT = 'ACCOUNT_MANAGEMENT_EDIT_DEPARTMENT',

  ORG_CFV = 'ORG_CFV', // keep this for comparePathnameAndSidebarItemUrl check menu active in sidebar
  ORG_CFV_DASHBOARD = 'ORG_CFV_DASHBOARD',
  ORG_CFV_PROJECT_EMISSION_IDENTIFICATION = 'ORG_CFV_PROJECT_EMISSION_IDENTIFICATION',
  ORG_CFV_PROJECT_EMISSION_IDENTIFICATION_EDIT = 'ORG_CFV_PROJECT_EMISSION_IDENTIFICATION_EDIT',
  ORG_CFV_PROJECT_EMISSION_SOURCES = 'ORG_CFV_PROJECT_EMISSION_SOURCES',
  ORG_CFV_PROJECT_CREATE_EMISSION_SOURCE = 'ORG_CFV_PROJECT_CREATE_EMISSION_SOURCE',
  ORG_CFV_PROJECT_VIEW_EMISSION_SOURCE = 'ORG_CFV_PROJECT_VIEW_EMISSION_SOURCE',
  ORG_CFV_PROJECT_EDIT_EMISSION_SOURCE = 'ORG_CFV_PROJECT_EDIT_EMISSION_SOURCE',
  ORG_CFV_PROJECT_RELEVANT_EMISSION_SOURCE = 'ORG_CFV_PROJECT_RELEVANT_EMISSION_SOURCE',
  ORG_CFV_PROJECT_ACTIVITY_DATA_ENTRY = 'ORG_CFV_PROJECT_ACTIVITY_DATA_ENTRY',
  ORG_CFV_PROJECT_CREATE_ACTIVITY_DATA_ENTRY = 'ORG_CFV_PROJECT_CREATE_ACTIVITY_DATA_ENTRY',
  ORG_CFV_PROJECT_EDIT_ACTIVITY_DATA_ENTRY = 'ORG_CFV_PROJECT_EDIT_ACTIVITY_DATA_ENTRY',
  ORG_CFV_PROJECT_CREATE_ACTIVITY_DATA_ENTRY_BULK = 'ORG_CFV_PROJECT_CREATE_ACTIVITY_DATA_ENTRY_BULK',
  ORG_CFV_PROJECT_EDIT_ACTIVITY_DATA_ENTRY_BULK = 'ORG_CFV_PROJECT_EDIT_ACTIVITY_DATA_ENTRY_BULK',
  ORG_CFV_PROJECT_ACTIVITY_DATA_ENTRY_DETAILS = 'ORG_CFV_PROJECT_ACTIVITY_DATA_ENTRY_DETAILS',
  ORG_CFV_PROJECT_ACTIVITY_DATA_APPROVAL = 'ORG_CFV_PROJECT_ACTIVITY_DATA_APPROVAL',
  ORG_CFV_PROJECT_ACTIVITY_DATA_APPROVAL_DETAILS = 'ORG_CFV_PROJECT_ACTIVITY_DATA_APPROVAL_DETAILS',
  ORG_CFV_PROJECT_DATA_COLLECTION = 'ORG_CFV_PROJECT_DATA_COLLECTION',
  ORG_CFV_PROJECT_DATA_COLLECTION_DETAILS = 'ORG_CFV_PROJECT_DATA_COLLECTION_DETAILS',
  ORG_CFV_DATA_QUALITY_MGMT = 'ORG_CFV_DATA_QUALITY_MGMT',
  ORG_CFV_DATA_QUALITY_MGMT_DESCRIPTION = 'ORG_CFV_DATA_QUALITY_MGMT_DESCRIPTION',
  ORG_CFV_UNCERTAINTY_QUANTITATIVE_ASSESSMENT = 'ORG_CFV_UNCERTAINTY_QUANTITATIVE_ASSESSMENT',

  // FACTORY_DATABASE = 'FACTORY_DATABASE',
  VENDOR = 'VENDOR',
  EDIT_VENDOR = 'EDIT_VENDOR',
  CREATE_VENDOR = 'CREATE_VENDOR',
  CREATE_VENDOR_BULK = 'CREATE_VENDOR_BULK',

  // New supplier master pages (trial)
  VENDOR_MASTER_TRIAL = 'VENDOR_MASTER_TRIAL',
  CREATE_VENDOR_MASTER_TRIAL = 'CREATE_VENDOR_MASTER_TRIAL',
  VIEW_VENDOR_MASTER_TRIAL = 'VIEW_VENDOR_MASTER_TRIAL',
  EDIT_VENDOR_MASTER_TRIAL = 'EDIT_VENDOR_MASTER_TRIAL',

  // New raw material pages (trial)
  RAW_MATERIAL_TRANSPORTATION_TRIAL = 'RAW_MATERIAL_TRANSPORTATION_TRIAL',
  CREATE_RAW_MATERIAL_TRANSPORTATION_TRIAL = 'CREATE_RAW_MATERIAL_TRANSPORTATION_TRIAL',
  VIEW_RAW_MATERIAL_TRANSPORTATION_TRIAL = 'VIEW_RAW_MATERIAL_TRANSPORTATION_TRIAL',
  EDIT_RAW_MATERIAL_TRANSPORTATION_TRIAL = 'EDIT_RAW_MATERIAL_TRANSPORTATION_TRIAL',
  CREATE_BULK_RAW_MATERIAL_TRANSPORTATION_TRIAL = 'CREATE_BULK_RAW_MATERIAL_TRANSPORTATION_TRIAL',

  RAW_MATERIAL = 'RAW_MATERIAL',
  CREATE_RAW_MATERIAL = 'CREATE_RAW_MATERIAL',
  EDIT_RAW_MATERIAL = 'EDIT_RAW_MATERIAL',
  RAW_MATERIAL_DETAIL = 'RAW_MATERIAL_DETAIL',
  EDIT_RAW_MATERIAL_BULK = 'EDIT_RAW_MATERIAL_BULK',
  CREATE_RAW_MATERIAL_BULK = 'CREATE_RAW_MATERIAL_BULK',
  CREATE_RAW_MATERIAL_BULK_AI = 'CREATE_RAW_MATERIAL_BULK_AI',
  CREATE_RAW_MATERIAL_BULK_MULTI_LINGUAL = 'CREATE_RAW_MATERIAL_BULK_MULTI_LINGUAL',
  RAW_MATERIAL_TRANSPORTATION = 'RAW_MATERIAL_TRANSPORTATION',
  CREATE_RAW_MATERIAL_TRANSPORTATION = 'CREATE_RAW_MATERIAL_TRANSPORTATION',
  EDIT_RAW_MATERIAL_TRANSPORTATION = 'EDIT_RAW_MATERIAL_TRANSPORTATION',

  WASTE_TRANSPORTATION = 'WASTE_TRANSPORTATION',
  CREATE_WASTE_TRANSPORTATION = 'CREATE_WASTE_TRANSPORTATION',
  CREATE_WASTE_TRANSPORTATION_BULK = 'CREATE_WASTE_TRANSPORTATION_BULK',
  EDIT_WASTE_TRANSPORTATION = 'EDIT_WASTE_TRANSPORTATION',

  DISTRIBUTION_TRANSPORTATION = 'DISTRIBUTION_TRANSPORTATION',
  CREATE_DISTRIBUTION_TRANSPORTATION = 'CREATE_DISTRIBUTION_TRANSPORTATION',
  CREATE_DISTRIBUTION_TRANSPORTATION_BULK = 'CREATE_DISTRIBUTION_TRANSPORTATION_BULK',
  EDIT_DISTRIBUTION_TRANSPORTATION = 'EDIT_DISTRIBUTION_TRANSPORTATION',

  PRODUCT_LINE = 'PRODUCT_LINE',
  CREATE_PRODUCT_LINE = 'CREATE_PRODUCT_LINE',
  CREATE_PRODUCT_LINE_BULK = 'CREATE_PRODUCT_LINE_BULK',
  EDIT_PRODUCT_LINE = 'EDIT_PRODUCT_LINE',
  CREATE_PRODUCT_SERIES = 'CREATE_PRODUCT_SERIES',
  CREATE_PRODUCT_SERIES_BULK = 'CREATE_PRODUCT_SERIES_BULK',
  EDIT_PRODUCT_SERIES = 'EDIT_PRODUCT_SERIES',
  PRODUCT_MATERIALS = 'PRODUCT_MATERIALS',
  CREATE_PRODUCT_MATERIALS_BULK = 'CREATE_PRODUCT_MATERIALS_BULK',

  SCENARIOS_CONFIGURATION = 'SCENARIOS_CONFIGURATION',
  USAGE_SCENARIOS = 'USAGE_SCENARIOS',
  CREATE_USAGE_SCENARIOS = 'CREATE_USAGE_SCENARIOS',
  EDIT_USAGE_SCENARIOS = 'EDIT_USAGE_SCENARIOS',
  USAGE_SCENARIOS_DETAIL = 'USAGE_SCENARIOS_DETAIL',
  END_OF_LIFE_SCENARIOS_DETAIL = 'END_OF_LIFE_SCENARIOS_DETAIL',
  END_OF_LIFE_SCENARIOS_CREATE = 'END_OF_LIFE_SCENARIOS_CREATE',
  END_OF_LIFE_SCENARIOS_EDIT = 'END_OF_LIFE_SCENARIOS_EDIT',

  EMPLOYEE = 'EMPLOYEE',
  EMPLOYEE_BULK = 'EMPLOYEE_BULK',

  EMPLOYEE_COMMUTING = 'EMPLOYEE_COMMUTING',
  EMPLOYEE_COMMUTING_BULK = 'EMPLOYEE_COMMUTING_BULK',
  EMPLOYEE_COMMUTING_CREATE = 'EMPLOYEE_COMMUTING_CREATE',
  EMPLOYEE_COMMUTING_EDIT = 'EMPLOYEE_COMMUTING_EDIT',

  MEMBER_PROFILE = 'MEMBER_PROFILE',
  MEMBER_MANUAL = 'MEMBER_MANUAL',
  MEMBER_BILLING_INFORMATION = 'MEMBER_BILLING_INFORMATION',
  MEMBER_NOTIFICATION_SETTINGS = 'MEMBER_NOTIFICATION_SETTINGS',
  MEMBER_FAQ_AND_SUPPORT = 'MEMBER_FAQ_AND_SUPPORT',
  MEMBER_LEGAL_DOCUMENTS = 'MEMBER_LEGAL_DOCUMENTS',
  MEMBER_CHANGE_PASSWORD = 'MEMBER_CHANGE_PASSWORD',

  MULTI_BOUNDARY_REPORT_EXPORT = 'MULTI_BOUNDARY_REPORT_EXPORT',
  SINGLE_BOUNDARY_REPORT_EXPORT = 'SINGLE_BOUNDARY_REPORT_EXPORT',
  REPORT_ORG_CFV_SINGLE_REPORT_EDITOR = 'REPORT_ORG_CFV_SINGLE_REPORT_EDITOR',
  REPORT_ORG_CFV_SINGLE_REPORT_EDITOR_VIEW = 'REPORT_ORG_CFV_SINGLE_REPORT_EDITOR_VIEW',

  PRODUCT_CFV = 'PRODUCT_CFV', // keep this for comparePathnameAndSidebarItemUrl check menu active in sidebar
  PRODUCT_CFV_ENERGY_RESOURCES = 'PRODUCT_CFV_ENERGY_RESOURCES',
  PRODUCT_CFV_SUPPORTING_DOCUMENT = 'PRODUCT_CFV_SUPPORTING_DOCUMENT',
  PRODUCT_CFV_DATA_ENTRY = 'PRODUCT_CFV_DATA_ENTRY',
  PRODUCT_CFV_DATA_ENTRY_BULK = 'PRODUCT_CFV_DATA_ENTRY_BULK',
  PRODUCT_CFV_DATA_ENTRY_DETAIL = 'PRODUCT_CFV_DATA_ENTRY_DETAIL',
  PRODUCT_CFV_DATA_APPROVAL = 'PRODUCT_CFV_DATA_APPROVAL',
  PRODUCT_CFV_DATA_APPROVAL_DETAIL = 'PRODUCT_CFV_DATA_APPROVAL_DETAIL',
  PRODUCT_CFV_DATA_COLLECTION = 'PRODUCT_CFV_DATA_COLLECTION',
  PRODUCT_CFV_DATA_COLLECTION_DETAIL = 'PRODUCT_CFV_DATA_COLLECTION_DETAIL',
  PRODUCT_CFV_DATA_COLLECTION_RAW_MATERIAL_APPROVAL = 'PRODUCT_CFV_DATA_COLLECTION_RAW_MATERIAL_APPROVAL',
  PRODUCT_CFV_DATA_COLLECTION_MANUFACTURING_APPROVAL = 'PRODUCT_CFV_DATA_COLLECTION_MANUFACTURING_APPROVAL',
  PRODUCT_CFV_DATA_COLLECTION_SALES_INFORMATION_APPROVAL = 'PRODUCT_CFV_DATA_COLLECTION_SALES_INFORMATION_APPROVAL',
  PRODUCT_CFV_DASHBOARD = 'PRODUCT_CFV_DASHBOARD',
  PRODUCT_CFV_REPORTING = 'PRODUCT_CFV_REPORTING',
  PRODUCT_CFV_REPORTING_EDIT = 'PRODUCT_CFV_REPORTING_EDIT',
  PRODUCT_CFV_REPORTING_PREVIEW = 'PRODUCT_CFV_REPORTING_PREVIEW',
  PRODUCT_CFV_ENERGY_RESOURCES_RESULT = 'PRODUCT_CFV_ENERGY_RESOURCES_RESULT',
  PRODUCT_CFV_ENERGY_RESOURCES_RESULT_DETAIL = 'PRODUCT_CFV_ENERGY_RESOURCES_RESULT_DETAIL',
  PRODUCT_CFV_DATA_QUALITY = 'PRODUCT_CFV_DATA_QUALITY',
  PRODUCT_CFV_DATA_QUALITY_DETAIL = 'PRODUCT_CFV_DATA_QUALITY_DETAIL',
  PRODUCT_CFV_SENSITIVITY_ANALYSIS = 'PRODUCT_CFV_SENSITIVITY_ANALYSIS',
  PRODUCT_CFV_SENSITIVITY_ANALYSIS_DETAIL = 'PRODUCT_CFV_SENSITIVITY_ANALYSIS_DETAIL',
  PRODUCT_CFV_EDIT_SENSITIVITY_ANALYSIS = 'PRODUCT_CFV_EDIT_SENSITIVITY_ANALYSIS',

  AI_TABLE_MAPPING = 'AI_TABLE_MAPPING',

  ORGANIZATIONAL_STRUCTURE_MANAGEMENT = 'ORGANIZATIONAL_STRUCTURE_MANAGEMENT',
  OSM_ORGANIZATIONAL_UNIT_CREATE = 'OSM_ORGANIZATIONAL_UNIT_CREATE',
  OSM_ORGANIZATIONAL_UNIT_VIEW = 'OSM_ORGANIZATIONAL_UNIT_VIEW',
  OSM_ORGANIZATIONAL_UNIT_EDIT = 'OSM_ORGANIZATIONAL_UNIT_EDIT',
  OSM_PARENT_ORGANIZATIONAL_UNIT_CREATE = 'OSM_PARENT_ORGANIZATIONAL_UNIT_CREATE',
  OSM_PARENT_ORGANIZATIONAL_UNIT_VIEW = 'OSM_PARENT_ORGANIZATIONAL_UNIT_VIEW',
  OSM_PARENT_ORGANIZATIONAL_UNIT_EDIT = 'OSM_PARENT_ORGANIZATIONAL_UNIT_EDIT',

  // SUPPLIER_MANAGEMENT = 'SUPPLIER_MANAGEMENT',
  SUPPLIER_MANAGEMENT_DATA_REQUEST = 'SUPPLIER_MANAGEMENT_DATA_REQUEST',
  SUPPLIER_MANAGEMENT_DATA_REQUEST_CREATE = 'SUPPLIER_MANAGEMENT__DATA_REQUEST_CREATE',
  SUPPLIER_MANAGEMENT_DATA_REQUEST_DETAILS = 'SUPPLIER_MANAGEMENT_DATA_REQUEST_DETAILS',
  SUPPLIER_DATA_ENTRY = 'SUPPLIER_DATA_ENTRY',

  BOUNDARY_PROJECT_MANAGEMENT = 'BOUNDARY_PROJECT_MANAGEMENT', // Big Project
  BOUNDARY_PROJECT_MANAGEMENT_CREATE = 'BOUNDARY_PROJECT_MANAGEMENT_CREATE',

  PROJECT_SETTINGS = 'PROJECT_SETTINGS',
  PROJECT_SETTINGS_EDIT = 'PROJECT_SETTINGS_EDIT',
  PROJECT_SETTINGS_PRODUCT_SERIES = 'PROJECT_SETTINGS_PRODUCT_SERIES',
  PROJECT_SETTINGS_PRODUCT_SERIES_DETAILS = 'PROJECT_SETTINGS_PRODUCT_SERIES_DETAILS',

  DASHBOARD = 'DASHBOARD',
  DASHBOARD_DEMO = 'DASHBOARD_DEMO',
  DASHBOARD_UPLOAD_INVENTORY = 'DASHBOARD_UPLOAD_INVENTORY',
  DASHBOARD_PREVIEW_FILE_CREATE = 'DASHBOARD_PREVIEW_FILE_CREATE',
  DASHBOARD_CHECK_UPLOAD_INVENTORY_PREVIEW_FILE_CREATE = 'DASHBOARD_CHECK_UPLOAD_INVENTORY_PREVIEW_FILE_CREATE',
  DASHBOARD_CHECK_UPLOAD_INVENTOR_PREVIEW_FILE_EDIT = 'DASHBOARD_CHECK_UPLOAD_INVENTOR_PREVIEW_FILE_EDIT',
  DASHBOARD_CHECK_UPLOAD_INVENTORY = 'DASHBOARD_CHECK_UPLOAD_INVENTORY',
  DASHBOARD_CHECK_UPLOAD_INVENTORY_UPLOAD_INVENTORY = 'DASHBOARD_CHECK_UPLOAD_INVENTORY_UPLOAD_INVENTORY',
  EMISSION_OVERVIEW = 'EMISSION_OVERVIEW',
}
